type IconProp = {
  className?: string;
};

export const CartIcon = ({ className }: IconProp) => (
  <svg
    width='18'
    height='18'
    viewBox='0 0 18 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={className}
  >
    <path
      d='M3.02051 1C4.4431 1.00009 5.68184 1.92295 6.11035 3.25H14.3721C15.7396 3.25021 16.7507 4.52331 16.4414 5.85547L15.4648 10.0654C15.2632 10.934 14.6216 11.6059 13.8096 11.873C14.5231 12.3133 15 13.1 15 14C15 15.3807 13.8807 16.5 12.5 16.5C11.1193 16.5 10 15.3807 10 14C10 13.1807 10.3959 12.456 11.0049 12H7.99512C8.60407 12.456 9 13.1807 9 14C9 15.3807 7.88071 16.5 6.5 16.5C5.11929 16.5 4 15.3807 4 14C4 13.0351 4.54719 12.199 5.34766 11.7822C4.62595 11.4602 4.07616 10.8056 3.91309 9.99023L2.81543 4.5H2.75C1.7835 4.5 1 3.7165 1 2.75C1 1.7835 1.7835 1 2.75 1H3.02051Z'
      fill='white'
      fillRule='evenodd'
      clipRule='evenodd'
      stroke='black'
      strokeWidth='2'
      strokeLinejoin='round'
    ></path>
  </svg>
);
